/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S1_Provider_PhoneInputs */

const tr_mesafeli_s1_provider_phone = /** @type {(inputs: Mesafeli_S1_Provider_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`; Telefon`)
};

const en_mesafeli_s1_provider_phone = /** @type {(inputs: Mesafeli_S1_Provider_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`; Phone`)
};

const de_mesafeli_s1_provider_phone = /** @type {(inputs: Mesafeli_S1_Provider_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`; Telefon`)
};

const ru_mesafeli_s1_provider_phone = /** @type {(inputs: Mesafeli_S1_Provider_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`; телефон`)
};

/**
* | output |
* | --- |
* | "; Phone" |
*
* @param {Mesafeli_S1_Provider_PhoneInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s1_provider_phone = /** @type {((inputs?: Mesafeli_S1_Provider_PhoneInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S1_Provider_PhoneInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s1_provider_phone(inputs)
	if (locale === "de") return de_mesafeli_s1_provider_phone(inputs)
	if (locale === "ru") return ru_mesafeli_s1_provider_phone(inputs)
	return tr_mesafeli_s1_provider_phone(inputs)
});